"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemCheck = SystemCheck;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _JoinComponent = require("../JoinComponent.styled");
var _ReadinessCheck = require("../../ReadinessCheck");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _constants = require("../../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function SystemCheck(_ref) {
  var runSystemCheck = _ref.runSystemCheck,
    joinMeeting = _ref.joinMeeting,
    goBack = _ref.goBack,
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? [] : _ref$errors,
    _ref$warnings = _ref.warnings,
    warnings = _ref$warnings === void 0 ? [] : _ref$warnings,
    checkStatus = _ref.checkStatus,
    _ref$isStandaloneChec = _ref.isStandaloneChecker,
    isStandaloneChecker = _ref$isStandaloneChec === void 0 ? false : _ref$isStandaloneChec;
  var checkInProgress = checkStatus === _constants.joinPageStatus.IN_PROGRESS;
  var browserBlock = checkStatus === _constants.joinPageStatus.BROWSER_BLOCK;
  var hasErrors = errors.length > 0 && !checkInProgress;
  var hasWarnings = warnings.length > 0 && !checkInProgress;
  var hasNoIssues = !(hasErrors || hasWarnings) && !checkInProgress;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showWarnings = _useState2[0],
    setShowWarnings = _useState2[1];
  var isJoinButtonDisabled = hasErrors || checkInProgress || browserBlock;
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h5"
  }, "System Check")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCheckSystemComponentContent, null, checkInProgress && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIconSpinner, {
    icon: _freeSolidSvgIcons.faSpinner,
    className: "fa-spin"
  }), " Checking your system for best performance..."), hasNoIssues && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: "#206B4A",
    icon: _freeSolidSvgIcons.faCheckCircle
  }), " You're all set! Join when you're ready. You won\u2019t be seen or heard by the audience when you join."), errors.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: "#DE2F1B",
    icon: _freeSolidSvgIcons.faExclamationCircle
  }), " You must fix these issues before joining Studio"), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIssueWrapper, null, errors.map(function (error) {
    return /*#__PURE__*/_react["default"].createElement(_JoinComponent.ReadinessCheckerMessagingWrapper, {
      key: error
    }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.ReadinessCheckerMessaging, {
      name: error
    }));
  }))), warnings.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, {
    role: "button",
    onClick: function onClick() {
      return setShowWarnings(!showWarnings);
    },
    "data-testid": "show-warnings-button",
    $accordion: true
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Fix these issues for the best Studio experience"), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledChevronIcon, {
    icon: _freeSolidSvgIcons.faChevronUp,
    $active: showWarnings
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIssueWrapper, {
    $active: showWarnings
  }, warnings.map(function (warning) {
    return /*#__PURE__*/_react["default"].createElement(_JoinComponent.ReadinessCheckerMessagingWrapper, {
      key: warning
    }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.ReadinessCheckerMessaging, {
      name: warning
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: goBack,
    color: "primary",
    variant: "link",
    disabled: checkInProgress,
    "data-testid": "back_button"
  }, "Back"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "run-test-button",
    disabled: checkInProgress,
    onClick: runSystemCheck,
    color: "outline"
  }, "Run Test"), !isStandaloneChecker && /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "join_button",
    disabled: isJoinButtonDisabled,
    onClick: joinMeeting,
    color: "primary"
  }, "Join")));
}
SystemCheck.propTypes = {
  runSystemCheck: _propTypes["default"].func,
  joinMeeting: _propTypes["default"].func,
  goBack: _propTypes["default"].func,
  errors: _propTypes["default"].array,
  warnings: _propTypes["default"].array,
  checkStatus: _propTypes["default"].string,
  isStandaloneChecker: _propTypes["default"].bool
};